export const DEFAULT_LAYOUT = {
  entityTableId: "saved-searches",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "summary", "favorite"],
  defaultColumnOrder: ["title", "summary", "description", "owner", "created_at", "last_updated_at", "favorite"]
};
